import React from 'react';

/**
 * Template 11: Photo + Minimal Overlay
 * Real photo background (full-bleed), short serif text overlaid bottom-left.
 *
 * Inspired by: "We tested it.", "Pulling makes it shorter"
 */
export default function V_PhotoOverlay({
  headline = 'We tested it.',
  bgImage,
  accentColor = '#E53935',
}) {
  return (
    <div style={{
      width: 1280, height: 720, position: 'relative', overflow: 'hidden',
      background: '#111', fontFamily: "'Playfair Display', serif",
    }}>
      {/* Full-bleed background photo */}
      {bgImage ? (
        <div style={{ position: 'absolute', inset: 0, zIndex: 1 }}>
          <img src={bgImage} alt="" style={{
            width: '100%', height: '100%', objectFit: 'cover',
          }} />
          {/* Subtle darkening vignette + bottom gradient */}
          <div style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(0deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.15) 35%, rgba(0,0,0,0.05) 100%)',
          }} />
        </div>
      ) : (
        <div style={{
          position: 'absolute', inset: 0, zIndex: 1,
          background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 32, color: 'rgba(255,255,255,0.08)',
        }}>BACKGROUND PHOTO</div>
      )}

      {/* Headline - bottom left, large serif */}
      <h1 style={{
        position: 'absolute', bottom: 50, left: 60, right: 200,
        margin: 0, fontSize: 88, fontWeight: 700, lineHeight: 1.1,
        color: '#FFFFFF', zIndex: 2,
        textShadow: '0 4px 24px rgba(0,0,0,0.9), 0 2px 4px rgba(0,0,0,0.6)',
      }}>
        {headline}
      </h1>

      {/* Subtle accent bar bottom-left */}
      <div style={{
        position: 'absolute', bottom: 36, left: 60, width: 60, height: 4,
        background: accentColor, zIndex: 2, borderRadius: 2,
      }} />
    </div>
  );
}
